module.exports = __webpack_public_path__ + "static/media/payment.722e6869.svg";